import React, { useState, FC, useCallback, CSSProperties, useEffect, useRef } from 'react';
import styles from './index.less';
import { IContentProps } from '../anim-tab-content';
import { ARROW_DOWN_ICON } from '@src/slide/domain/ui-model/element-modeles/property/animation/anim-icon';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { IAnimCategory, IAnimConfig } from '@src/slide/domain/ui-model/element-modeles/property/animation/constants';
import i18n from '@i18next/i18n';
import AnimGallery from '../anim-gallery';
import { AnimationHistory } from '@src/framework/frame/components/animation-editor/animationHistory';
import { AnimType } from '@tencent/slide-sdk-model';
interface IProps {
    onClick: (id: string) => void;
    // 用于的展示的list
    animCategoryList: IAnimCategory[];
    // 左侧文案
    title: string;
    // 要展示的图标数量
    num: number;
    // tab栏展示的模块
    TabContent: FC<IContentProps>;
    // 被选中的元素id
    selectedId: string;
    // 展开后的内容模块,默认和tabContent同一组件
    SpreadContent?: FC<IContentProps>;
    // 是否展示下拉箭头，默认true
    showArrow?: boolean;
    // 总宽度
    totalWidth?: number;
    // 总高度
    totalHeight?: number;
    // 展示位wrapper样式
    tabStyle?: CSSProperties;
    // 展开面板wrapper样式
    spreadStyle?: CSSProperties;
}

const AnimTabPanel = (props: IProps) => {
    const panelRef = useRef<HTMLDivElement>(null);
    const isEnLan = i18n.language === 'en-US' || i18n.language === 'en';
    const {
        onClick,
        animCategoryList,
        title,
        showArrow = false,
        num,
        totalWidth = 384,
        totalHeight = 52,
        TabContent,
        SpreadContent = TabContent,
        tabStyle = {},
        spreadStyle = { top: -57, left: isEnLan ? 5 : 0 },
        selectedId = '',
    } = props;
    const getAnimConfigList = (categoryList: IAnimCategory[]): IAnimConfig[] => categoryList.reduce(
        (previousValue, currentValue) => [...previousValue, ...currentValue.children],
        [],
    );

    const [tabList, setTabList] = useState(getAnimConfigList(animCategoryList).slice(0, num));
    const [visible, setVisible] = useState(false);
    const handleVisibleChange = useCallback((visible) => {
        setVisible(visible);
    }, []);

    useEffect(() => {
        const isInTab = tabList.some((animConfig: IAnimConfig) => animConfig.id === selectedId);
        if (isInTab) return;
        const animConfigList = getAnimConfigList(animCategoryList);
        const index = animConfigList.findIndex((animConfig: IAnimConfig) => animConfig.id === selectedId);
        if (index === -1) return;

        const animTotalLength = animConfigList.length;
        if (index < num - 1) {
            const endIndex = index > animTotalLength - 1 - num ? animTotalLength : index + num;
            const list = animConfigList.slice(index, endIndex);
            setTabList(list);
            return;
        }
        if (index > animTotalLength - 1 - num) {
            const startIndex = index < num - 1 ? 0 : index - num + 1;
            const list = animConfigList.slice(startIndex, index + 1);
            setTabList(list);
            return;
        }

        let mid = num / 2;
        if (!Number.isInteger(mid)) {
            mid = Math.ceil(mid);
        }
        const startIndex = index - mid + 1;
        const list = animConfigList.slice(startIndex, startIndex + num);
        setTabList(list);
    }, [selectedId]);

    useEffect(() => {
        const animConfigList = getAnimConfigList(animCategoryList);
        setTabList(animConfigList.slice(0, num));
    }, [animCategoryList]);

    const handleClick = useCallback((id: string) => {
        // 将操作加入最近使用
        AnimationHistory.getInstance().setAnimationHistory(id as AnimType);
        onClick(id);
    }, [animCategoryList]);

    const renderDropdown = () => {
        if (panelRef.current) {
            const { width, y } = panelRef.current.getBoundingClientRect();
            const maxHeight = window.innerHeight - y - 10;
            return (
                <div
                    className={styles['spread-wrapper']}
                    style={{
                        width,
                        maxHeight,
                        position: 'relative',
                        ...spreadStyle,
                    }}
                >
                    <AnimGallery
                        onClick={handleClick}
                        animCategoryList={animCategoryList}
                        selectedId={selectedId}
                        width={width}
                        showArrow={showArrow}
                    />
                </div>
            );
        }
        return null;
    };

    return (
        <div className={styles['anim-tab-panel']} ref={panelRef}>
            <div className={styles.up} style={{ height: totalHeight, ...tabStyle }}>
                {
                    isEnLan ? null :  <div className={styles.left}>
                        {title.split('').map((char, index) => (
                            <p className={styles['left-item']} key={index}>
                                {char}
                            </p>
                        ))}
                    </div>
                }
                <div className={styles.middle}>
                    {tabList.map((item) => {
                        const { id, label, icon, disabled } = item;
                        return (
                            <TabContent
                                id={id}
                                icon={icon}
                                label={label}
                                key={id}
                                onClick={handleClick}
                                style={{ padding: '0 6px', marginRight: '4px' }}
                                selected={selectedId === id}
                                disabled={disabled}
                            />
                        );
                    })}
                </div>
                {showArrow && (
                    <Dropdown
                        dropContent={showArrow ? renderDropdown() : null}
                        visible={visible}
                        onVisibleChange={handleVisibleChange}
                        alignment="right"
                    >
                        <div className={styles.right} style={{ height: totalHeight }} id={`tab-panel-right-arrow-${title}`}>
                            <img src={ARROW_DOWN_ICON} className={styles['right-icon']} />
                        </div>
                    </Dropdown>
                )}
            </div>
        </div>
    );
};

export default AnimTabPanel;
